export default __webpack_public_path__ + "static/004-923dfb21f901bed63d98ec16910c1b6e.jpg";